export default {
  title: {
    id: 'bo_sellers-listing-search-product-title',
    defaultMessage: 'Create a listing',
  },
  subtitle: {
    id: 'bo_sellers-listing-search-product-subtitle',
    defaultMessage:
      'Start by searching the Back Market catalog for an item you’re ready to sell. Can’t find the item you’re looking for?',
  },
  addNewProductLink: {
    id: 'bo_sellers-listing-search-product-add-new-product-link',
    defaultMessage: 'Add new item to the catalog',
  },
  formFieldSearchLabel: {
    id: 'bo_sellers-listing-search-product-form-field-search-label',
    defaultMessage: 'Search',
  },
  formFieldSearchPlaceholder: {
    id: 'bo_sellers-listing-search-product-form-field-search-placeholder',
    defaultMessage: 'Try Iphone 8',
  },
  sectionResultsTitle: {
    id: 'bo_sellers-listing-search-product-section-results-title',
    defaultMessage: 'The results of your search',
  },
  loadingScreenTitle: {
    id: 'bo_sellers-listing-search-product-loading-screen-title',
    defaultMessage: 'Searching the catalog...',
  },
  errorTitle: {
    id: 'bo_sellers-listing-search-product-error-title',
    defaultMessage: 'Oups something went wrong!',
  },
}
